import React, { useState, useEffect, useRef } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from "react-loading-skeleton";
import axiosInstance from "./../../helpers/axiosInstance";
import MyModal from "components/Modal/Modal";
import santander from '../../assets/img/brand/santander.png';
import exitoCreacion from '../../assets/img/illustrations/add-contact-success.svg';
import ComponentemodificaUsu from './modificaUsuario.js'


// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  Modal,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Alert,
} from "reactstrap";
import { normalizeUnits } from "moment";
import { tr } from "date-fns/locale";
import basePerfiles from "./basePerfiles.js";
import baseUsuarios from "./baseUsu.js";
import { set } from "date-fns";
import baseTransaccionPen from "./baseTransaccionesPen.js";
import Compotp from "./Compotp";
import Checksantader from "./Checksantander";
import perf from "./basePerfiles.js";
import IconNid from '../../assets/img/icons/Icono-Numero-documento-Gris.png';
import IconCorreo from '../../assets/img/icons/Icono-Correo-Gris.png';
import IconNom from '../../assets/img/icons/Cliente-Gris2x.png';
import IconCel from '../../assets/img/icons/Telefono-Gris2x.png';
import IconPesos from '../../assets/img/icons/Tope_Monto_Transaccional-Gris2x.png';
//import { Console } from "console";
const _=require("lodash");

const Campoformato=(props)=>{
    const refMaxValue = useRef(null);
    const refMaxDailyValue = useRef(null);
    const [maxDaily,setmaxDaily]=useState(props.data.maxDaily);
    const [maxTransaction,setmaxTransaction]=useState(props.data.maxTransaction);
    const [checkotp,setcheckotp]=useState(props.data.otp);
    const [checksupervisor,setchecksupervisor]=useState(props.data.supervisor);
    const [checkconsulta,setcheckconsulta]=useState(props.data.consulta);
    const [checktransaccion,setchecktransaccion]=useState(props.data.transaccion);
    const [muestramodal,setmuestramodal]=useState(false);
    const [listAlert, setListAlert] = useState([]);
    var createReactClass = require("create-react-class");
    
    console.log(props.data);
    const ejecutafin=()=>{
        let permisosedit={
            maxDaily:maxDaily,
            maxTransaction:maxTransaction,
            otp:checkotp,
            supervisor:checksupervisor,
            consulta:checkconsulta,
            transaccion:checktransaccion   
        }
       
        console.log("funcion compara topes" + parseFloat(maxDaily.replaceAll(",","")) + ">" + parseFloat(maxTransaction.replaceAll(",","")));

         if (parseFloat(maxDaily.replaceAll(",","")) >= parseFloat(maxTransaction.replaceAll(",",""))) {
            props.terminar(permisosedit);
         }else{
                setListAlert([
                 {
                   description: "El tope transaccional no puede superar el tope diario.",
                   type: "alert alert-alert show alert-dismissible fade alert-danger",
                   icon: "fas fa-exclamation-circle"
                }
               ]); 
         }
   
    }
    const ejecutasalir=()=>{
        props.salir();
    }
    const deleteAlert = (alert) => {
    
        console.log("elimina alerta");
        console.log(listAlert);
        setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
      };
    var Alerts = createReactClass({
        render: function () {
          var data = this.props.data;
          var newsTemplate;
          if (data.length > 0) {
            newsTemplate = data.map(function (item, index) {
              return (
                <div class={item.type} role="alert">
                  <button
                    type="button"
                    class="close"
                    aria-label="Close"
                    onClick={() => deleteAlert(item)}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                  <span className="alert-inner--icon mr-3">
                    <i className={item.icon} />
                  </span>{" "}
                  <span class="alert-inner--text">{item.description}</span>
                </div>
              );
            });
          }
          return <div className="toast-bottom-right">{newsTemplate}</div>;
        },
      });

    const cambioTopetotal = (event) => {
        event.preventDefault();
        let val = event.target.value;
        setmaxTransaction(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        //console.log(topesxprod);
        refMaxValue.current.focus();
      };
      useEffect(()=>{
        if(props.pideotp){
          setmuestramodal(true);
        }
    
      },props.pideotp);
    const toggleModal=()=>{
        if(muestramodal){
          setmuestramodal(false);
          props.funcrespadre("");
        }else{
          setmuestramodal(true);
        }
      }
     
      const cambioTopediario = (event) => {
        event.preventDefault();
        let val = event.target.value;
        setmaxDaily(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        //console.log(topesxprod);
        refMaxDailyValue.current.focus();
      };

    const controlcheck=(id,estado)=>{
        console.log("id: " + id + " estado: " + estado);
        if(id=="otp" || id=="supervisor"){
            if(id=="otp"){
                if(estado){
                    if(checksupervisor){
                        setchecksupervisor(false);
                        console.log("debe cambiar supervisor");
                    }
                }
                setcheckotp(estado);
            }else{
                if(estado){
                    if(checkotp){
                        setcheckotp(false);
                        console.log("debe cambiar otp");
                    }
                }
                setchecksupervisor(estado)
            }
        }

        if(id=="consulta" || id=="transaccion"){
            if(id=="consulta"){
                if(estado){
                    if(checktransaccion){
                        setchecktransaccion(false);
                        console.log("debe cambiar transaccion");
                    }
                }
                setcheckconsulta(estado);
            }else{
                if(estado){
                    if(checkconsulta){
                        setcheckconsulta(false);
                        console.log("debe cambiar consulta");
                    }
                }
                setchecktransaccion(estado)
            }
        }
    }

    switch(props.replica){
        case 1:
            return (
                <div className="header pb-4 pt-5 pt-md-8">
                    
                    <Container fluid>
                        <div className="header-body">
                        <Nav
                            className="justify-content-center flex-column flex-md-row"
                            id="tabs-icons-text"
                            pills
                            role="tablist"
                        >
                            {/*
                            <NavItem>
                            <NavLink
                                aria-selected={tabs === 1}
                                className={classnames(
                                "card-body ml-2 mb-2 mb-xl-0 shadow",
                                {
                                    active: tabs === 1,
                                }
                                )}
                                onClick={(e) => this.toggleNavs(e, "tabs", 1)}
                                href=""
                                role="tab"
                            >
                                <Row className="justify-content-center m-2">
                                <div className="icon icon-shape">
                                    <img
                                    className="my-header-image mt-5"
                                    src={
                                        require("../../assets/img/illustrations/Icono-Cambiar-Contraseña-Rojo.png")
                                        .default
                                    }
                                    />
                                </div>
                                </Row>
                                <Row className="justify-content-center m-2">
                                <p
                                    className="mt-3 mb-0 text-bold text-primary"
                                    style={{
                                    fontSize: 13 + "px",
                                    width: 101 + "px",
                                    textAlign: "center",
                                    lineHeight: 1.43,
                                    }}
                                >
                                    Cambiar Contraseña
                                </p>
                                </Row>
                            </NavLink>
                            </NavItem>
                            <NavItem>
                            <NavLink
                                aria-selected={tabs === 2}
                                className={classnames(
                                "card-body ml-2 mb-2 mb-xl-0 shadow",
                                {
                                    active: tabs === 2,
                                }
                                )}
                                onClick={(e) => this.toggleNavs(e, "tabs", 2)}
                                href=""
                                role="tab"
                            >
                                <Row className="justify-content-center m-2">
                                <div className="icon icon-shape">
                                    <img
                                    className="my-header-image mt-5"
                                    src={
                                        require("../../assets/img/illustrations/Icono-Actualizar-Datos-Usuario-Rojo.png")
                                        .default
                                    }
                                    />
                                </div>
                                </Row>
                                <Row className="justify-content-center m-2 text-primary">
                                <p
                                    className="mt-3 mb-0 text-bold"
                                    style={{
                                    fontSize: 13 + "px",
                                    width: 101 + "px",
                                    textAlign: "center",
                                    lineHeight: 1.43,
                                    }}
                                >
                                    Actualizar Datos del Usuario
                                </p>
                                </Row>
                            </NavLink>
                            </NavItem>
                            <NavItem>
                            <NavLink
                                aria-selected={tabs === 3}
                                className={classnames(
                                "card-body ml-2 mb-2 mb-xl-0 shadow",
                                {
                                    active: tabs === 3,
                                }
                                )}
                                onClick={(e) => this.toggleNavs(e, "tabs", 3)}
                                href=""
                                role="tab"
                            >
                                <Row className="justify-content-center m-2">
                                <div className="icon icon-shape">
                                    <img
                                    className="my-header-image mt-5"
                                    src={
                                        require("../../assets/img/illustrations/Icono-Administrar-Perfiles-Rojo.png")
                                        .default
                                    }
                                    />
                                </div>
                                </Row>
                                <Row className="justify-content-center m-2 text-primary">
                                <p
                                    className="mt-3 mb-0 text-bold"
                                    style={{
                                    fontSize: 13 + "px",
                                    width: 101 + "px",
                                    textAlign: "center",
                                    lineHeight: 1.43,
                                    }}
                                >
                                    Administrar Perfiles
                                </p>
                                </Row>
                            </NavLink>
                            </NavItem>
                                */}
                            <NavItem>
                            <NavLink
                                style={{"padding-top":0 +"rem"}}
                                
                                className="card-body ml-1 mb-0 pb-0 mb-xl-0 shadow h-100"
                                
                                href=""
                            >
                                <Row className="justify-content-center " style={{"padding":0 +"rem","height":"45%"}}>
                                <div className="icon icon-shape mt-0 mb-0 pb-0" style={{"padding":0 +"rem"}}>
                                    <img
                                    className="my-header-image mt-0 mb-1 pt-0"
                                    src={
                                        require("../../assets/img/icons/Icono-Administrar-Usuarios-Verde.png")
                                        .default
                                    }
                                    />
                                </div>
                                </Row>
                                <Row className="justify-content-center mt-0 pb-0 text-green">
                                <p
                                    className="mt-0 mb-0 pt-0 text-bold"
                                    style={{
                                    fontSize: 15 + "px",
                                    width: 100 + "px",
                                    textAlign: "center",
                                    "line-height":1.25 +'em',
                                    }}
                                >
                                    Administrar Usuarios
                                </p>
                                </Row>
                            </NavLink>
                            </NavItem>
                            {/*
                            <NavItem>
                            <NavLink
                                aria-selected={tabs === 7}
                                className={classnames(
                                "card-body ml-2 mb-2 mb-xl-0 shadow",
                                {
                                    active: tabs === 7,
                                }
                                )}
                                onClick={(e) => this.toggleNavs(e, "tabs", 7)}
                                href=""
                                role="tab"
                            >
                                <Row className="justify-content-center m-2">
                                <div className="icon icon-shape">
                                    <img
                                    className="my-header-image mt-5"
                                    src={
                                        require("../../assets/img/illustrations/administrate-user.svg")
                                        .default
                                    }
                                    />
                                </div>
                                </Row>
                                <Row className="justify-content-center m-2 text-primary">
                                <p
                                    className="mt-3 mb-0 text-bold"
                                    style={{
                                    fontSize: 13 + "px",
                                    width: 101 + "px",
                                    textAlign: "center",
                                    lineHeight: 1.43
                                    }}
                                >
                                    Transacciones pendientes
                                </p>
                                </Row>
                            </NavLink>
                            </NavItem>
                                */}
                        </Nav>
                        </div>
                    </Container>  
                    <div className="modalfondooscuro">
                        <div className="contenidomodal">
                            <div className="iteriormodal">
                                <div onClick={ejecutasalir} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-25px -30px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
                                <div style={{display:"flex",justifyContent:"center",alignItems:"center",margin:"0px 0px 16px 0px"}}>
                                    <h1 className="h1santander">Información del Producto</h1>
                                </div>
                                <p style={{margin:"0px 0px 0px 0px"}}>Tipo de acceso</p>
                                <div style={{margin:"3px 0px 19px -5px", display:"flex",flexDirection:"row"}}>
                                    <Checksantader mensaje={"Consulta"} funcionpadre={controlcheck} idCheck={"consulta"} estadocheck={checkconsulta} permisocambio={!checktransaccion}></Checksantader>
                                    <Checksantader mensaje={"Transacción"} funcionpadre={controlcheck} idCheck={"transaccion"} estadocheck={checktransaccion} permisocambio={!checkconsulta}></Checksantader>
                                </div>
                                <p style={{margin:"0px 0px 0px 0px"}}>Tipo de validación</p>
                                <div style={{margin:"3px 0px 19px -5px", display:"flex",flexDirection:"row"}}>
                                    <Checksantader mensaje={"OTP"} funcionpadre={controlcheck} idCheck={"otp"} estadocheck={checkotp} permisocambio={!checksupervisor}></Checksantader>
                                    <Checksantader mensaje={"Supervisor"} funcionpadre={controlcheck} idCheck={"supervisor"} estadocheck={checksupervisor} permisocambio={!checkotp && props.esSupervisor == "N"}></Checksantader>
                                </div>
                                <p style={{margin:"0px 0px 0px 0px"}}>Tope monto transaccional</p>
                                <div className="inputs-icons-borderbott" style={{margin:"8px 0px 24px 0px"}}>
                                    <input
                                    
                                    placeholder="Tope transaccional"
                                    type="text"
                                    ref={refMaxValue}
                                    onChange={cambioTopetotal}
                                    value={maxTransaction}
                                    style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                    
                                    />
                                    <img style={{height:"12px", }} src={IconPesos}></img>
                                </div>
                                <p style={{margin:"0px 0px 0px 0px"}}>Tope diario transaccional</p>
                                <div className="inputs-icons-borderbott" style={{margin:"8px 0px 24px 0px"}}>
                                    <input
                                    placeholder="Tope diario"
                                    type="text"
                                    ref={refMaxDailyValue}
                                    onChange={cambioTopediario}
                                    value={maxDaily}
                                    style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                    />
                                    <img style={{height:"12px", }} src={IconPesos}></img>
                                </div>
                                <div style={{display:"flex",justifyContent:"center",alignItems:"center", width:"100%"}}>
                                    <div style={{display:"flex",justifyContent:"center",alignItems:"center", width:"60%"}}>
                                        <button onClick={ejecutafin} className="btn bg-green text-white btn-block">Guardar</button>
                                    </div>
                                </div>
                                <Alerts data={listAlert}></Alerts>
                                
                            </div>
                        </div>
                        
                    </div>  
                </div> 
            );
            break;
        case 2:
            return(
                
                    <div className="modalfondooscuro">
                        <div className="contenidomodal">
                            <div className="iteriormodal">
                                <div onClick={ejecutasalir} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"0px 0px 0px 0px",fontSize:"20px"}}>X</h1>
                                </div>
                                <div style={{display:"flex",justifyContent:"center",alignItems:"center",margin:"0px 0px 16px 0px"}}>
                                    <h1 className="h1santander">Información del Producto</h1>
                                </div>
                                <p style={{margin:"0px 0px 0px 0px"}}>Tipo de acceso</p>
                                <div style={{margin:"3px 0px 19px -5px", display:"flex",flexDirection:"row"}}>
                                    <Checksantader mensaje={"Consulta"} funcionpadre={controlcheck} idCheck={"consulta"} estadocheck={checkconsulta} permisocambio={!checktransaccion}></Checksantader>
                                    <Checksantader mensaje={"Transacción"} funcionpadre={controlcheck} idCheck={"transaccion"} estadocheck={checktransaccion} permisocambio={!checkconsulta}></Checksantader>
                                </div>
                                <p style={{margin:"0px 0px 0px 0px"}}>Tipo de validación</p>
                                <div style={{margin:"3px 0px 19px -5px", display:"flex",flexDirection:"row"}}>
                                    <Checksantader mensaje={"OTP"} funcionpadre={controlcheck} idCheck={"otp"} estadocheck={checkotp} permisocambio={!checksupervisor}></Checksantader>
                                    <Checksantader mensaje={"Supervisor"} funcionpadre={controlcheck} idCheck={"supervisor"} estadocheck={checksupervisor} permisocambio={!checkotp && props.esSupervisor == "N"}></Checksantader>
                                </div>
                                <p style={{margin:"0px 0px 0px 0px"}}>Tope monto transaccional</p>
                                <div className="inputs-icons-borderbott" style={{margin:"8px 0px 24px 0px"}}>
                                    <input
                                    
                                    placeholder="Tope transaccional"
                                    type="text"
                                    ref={refMaxValue}
                                    onChange={cambioTopetotal}
                                    value={maxTransaction}
                                    style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                    
                                    />
                                    <img style={{height:"12px", }} src={IconPesos}></img>
                                </div>
                                <p style={{margin:"0px 0px 0px 0px"}}>Tope diario transaccional</p>
                                <div className="inputs-icons-borderbott" style={{margin:"8px 0px 24px 0px"}}>
                                    <input
                                    placeholder="Tope diario"
                                    type="text"
                                    ref={refMaxDailyValue}
                                    onChange={cambioTopediario}
                                    value={maxDaily}
                                    style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                    />
                                    <img style={{height:"12px", }} src={IconPesos}></img>
                                </div>
                                <div style={{display:"flex",justifyContent:"center",alignItems:"center", width:"100%"}}>
                                    <div style={{display:"flex",justifyContent:"center",alignItems:"center", width:"60%"}}>
                                        <button onClick={ejecutafin} className="btn bg-green text-white btn-block">Guardar</button>
                                    </div>
                                </div>
                                 <Alerts data={listAlert}></Alerts>
                            </div>
                        </div>
                    </div>
          
            );
            break;
        default:
            return(
                <div></div>
            )
    }
    

}

export default Campoformato;